
import Bluetooth from "../../../assets/duotone/Bluetooth.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BluetoothIcon({ className, dataTestid = "BluetoothIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bluetooth data-testid={dataTestid} className={classes} {...rest} />
  );
}
